class _SkillsAPI {
  constructor() {
    this.perPage = 'all';
    this.versionPrefix = '/v2';
    this.url = `${this.versionPrefix}/image-creators/`;
  }

  /**
   * Initialize.
   * TEMPORARY:
   *    The whole axios / auth should be replaced by proper install & usage.
   * @param {object} $axios - @nuxtjs/axios instance
   */
  init($axios) {
    this.API = $axios;
  }

  /**
   * Fetch the skills list of the IC
   * @param {string} userId - The IC Id
   */
  async fetchICSkills(userId) {
    const requestURL = `${this.url}${userId}/skills`;
    try {
      const response = await this.API.get(requestURL);
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * Create a Skill request
   * @param payload
   * @returns {Promise<unknown>}
   */
  async requestSkill(payload) {
    const requestURI = `${this.url}${payload.operatorId}/skills/${payload.skillId}`;
    try {
      const response = await this.API.post(requestURI, {
        data: {
          type: 'product_subtype',
          attributes: {
            link: payload.link,
          },
        },
      });
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

const SkillsAPI = new _SkillsAPI();
export default SkillsAPI;
